import React from 'react'
import { useTranslation } from 'react-i18next';
import Close from '../../Icons/Close'
import iconValider from '../../styles/img/icon-check-white.svg';
import Img from 'react-image';

const IconValider = () => <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />

export default function ModalOk(props) {
  const { t } = useTranslation();
  return (
    <div className="modal show modal-skin" style={{ background: "rgba(0, 76, 197, 0.7)" }} id="modalMdpOk" tabIndex="-1" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <form onSubmit={(e) => { e.preventDefault(); props.handleSubmit(); }}>
            <button type="button" onClick={props.closeModal} className="close" data-dismiss="modal" aria-label="Close">
              <Close className="img-fluid" alt="" />
            </button>
            <div className="modal-body">
              <section>
                <h5 className="modal-title">{props.title}</h5>
              </section>
              <section>
                <h5>{props.message}</h5>
              </section>
              <p className="bottom-space"></p>
              <section>
                <div className="d-flex justify-content-center">
                  <button type="submit" className="btn-gradient btn-confirm">
                    <Img src={IconValider} className="img-fluid" alt="" />
                    {props.button ? props.button : t('common.confirm')}</button>
                </div>
              </section>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
